module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_CJEnM_m.cea2c2316c092657ab245111405b15b0.png";